<app-search-grid
  i18n-header
  header="Users"
  [service]="userService"
  [columnDefs]="columnDefs"
  [showIncludeAll]="true"
  [allowIncludeAllBlankSearch]="true"
  [allowNavigateOnSingleResult]="false"
></app-search-grid>
